import { Injectable, inject, signal } from '@angular/core';
import { NotificationsService } from './notifications.service';

/** In-memory cache for the pending notification count; refetches at most every 30 minutes. */
@Injectable({ providedIn: 'root' })
export class CustomerTaskTodayCountCacheService {
  private readonly notificationsService = inject(NotificationsService);

  /** `null` until the first successful fetch (or failed attempt that maps to 0). */
  readonly pendingCount = signal<number | null>(null);

  private lastFetchedAt = 0;
  private static readonly TTL_MS = 30 * 60 * 1000;

  constructor() {
    const intervalMs = CustomerTaskTodayCountCacheService.TTL_MS;
    if (typeof window !== 'undefined' && !(window as unknown as { __karma__?: unknown }).__karma__) {
      window.setInterval(() => this.fetchAndCache(), intervalMs);
    }
  }

  /**
   * Loads count when missing or older than 30 minutes (e.g. after login on dashboard).
   */
  refreshIfStale(): void {
    const now = Date.now();
    const cached = this.pendingCount();
    if (cached !== null && now - this.lastFetchedAt < CustomerTaskTodayCountCacheService.TTL_MS) {
      return;
    }
    this.fetchAndCache();
  }

  /** Refetches pending count immediately (e.g. after marking notification(s) read). */
  refresh(): void {
    this.fetchAndCache();
  }

  private fetchAndCache(): void {
    this.notificationsService
      .getPendingNotificationsCount()
      .subscribe((n: number | null) => {
        this.pendingCount.set(n ?? 0);
        this.lastFetchedAt = Date.now();
      });
  }
}
